<script>
import CreatorLink from '@/components/News/NewsItemText/TextSubElement/CreatorLink.vue';

export default {
  components: { CreatorLink },
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <creator-link :news="news"/>
    {{$t('news.template.proposal.torchPassed.p1')}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[2]}}">
      "{{ news.textParams[3] }}"
    </router-link>
    {{$t('news.template.proposal.torchPassed.p2')}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[4]}}">
      "{{ news.textParams[5] }}"
    </router-link>.
  </div>
</template>
